// extracted by mini-css-extract-plugin
export default {"caixona":"p4_caixona__CAMIj","caixa":"p4_caixa__v2leF"};